import { ClientLogger } from 'bernie-client';
import type { Controller, FetchOptions } from 'bernie-core';
import { codeSplit } from 'bernie-core';
import type { PageData } from 'bernie-http';
import type { PageStore } from 'bernie-plugin-mobx';

import { TRIP_ITEM_ITINERARY_CONTROLLER_INFO } from 'logging/log-events';
import { logDetailedEvent } from 'logging/logger';

import { BASEPATH } from 'constants/basepath';

/**
 * /trips/75555523444/details/23424234755/trip-itinerary.pdf
 */
export class TripItemItineraryController implements Controller {
  public readonly bundles = [];
  public readonly pageId = 'page.Trip.ItemItinerary,U,80';
  public readonly routeName = 'trip-item-itinerary';
  public readonly exact = true;
  /**
   * Note that the tripViewId path param is optional since travelers can access the item itinerary
   * page for a cancelled booking that does not have an associated trip.
   */
  public readonly path = `${BASEPATH}/trips/:tripViewId([a-z0-z-]+)?/details/:tripItemId([a-z0-z-]+)/trip-itinerary.pdf`;
  public readonly component = codeSplit(
    /* istanbul ignore next */
    () => import(/* webpackChunkName: "trip-item-itinerary" */ 'views/trip-item-itinerary-view')
  );
  public readonly pageName = 'page.Trip.ItemItinerary';
  public readonly clickstreamPageName = 'Trip Item Itinerary';

  public shouldStreamResponse(): boolean {
    return false;
  }

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      pageId: this.pageId,
      pageName: this.pageName,
      clickstreamPageName: this.clickstreamPageName,
      title: '' // as page title will be set from graph response
    });
  }

  public fetch(options: FetchOptions): Promise<void> {
    const { stores } = options;

    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    logDetailedEvent(options.logger, TRIP_ITEM_ITINERARY_CONTROLLER_INFO, {
      request: options.request,
      message: 'Request made to trips-item-itinerary-controller'
    });

    return Promise.resolve();
  }
}
